<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).ready(function () {

    $('.ann-bar-sec-blocks').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        vertical: true,
        verticalSwiping: true,
        dots: false,
        arrows: false
    });

    $('body').on('click','.accordions-sec-block', function(){
        $(this).toggleClass('active');
        $(this).find('.accordions-sec-block-text').slideToggle();
    });

     $('.article-content-product-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });

    $('.love-from-parent-blocks').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.image-text-slider-blocks').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $("body").on("click", ".productView_offer-wrap-btn", function () {
        var copy_text = $(this);
        var text = $(this).attr('data-code');
        var copy_svg = $(this).text();
        var $temp = $("<input>");

        $("body").append($temp);
        $temp.val(text).select();
        document.execCommand("copy");
        $temp.remove();
        copy_text.html('Copied');
        
        setTimeout(function () {
        copy_text.html(copy_svg);
        }, 1000);
    })

    $("body").on("click", ".faq-custom-sec-block-title", function () {
        var activeTitle = $(this);
        activeTitle.toggleClass("active");
        var currentDropdown = activeTitle.next(".faq-custom-sec-block-text");
        $(".faq-custom-sec-block-title").not(activeTitle).removeClass("active");
        $(".faq-custom-sec-block-text").not(currentDropdown).slideUp();
        currentDropdown.stop(true, true).slideToggle();
    });

})